import { memo } from 'react'
import { ProfitSharesList } from '../profit-shares-list/profit-shares-list'

const Component = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold">My Profits</h1>
      <ProfitSharesList />
    </div>
  )
}

export const MyProfits = memo(Component)